import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694efc4e66cdef001448ba8b/new_capital_epc/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/694efc4e66cdef001448ba8b/new_capital_epc/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/694efc4e66cdef001448ba8b/new_capital_epc/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/694efc4e66cdef001448ba8b/new_capital_epc/src/styles/tailwind.css");
